// extracted by mini-css-extract-plugin
module.exports = {"tag":"style__tag__rAZfD","green":"style__green__CJ93Z","red":"style__red__of08a","yellow":"style__yellow__dqKIj","grey":"style__grey__UtEmz"};